import gql from 'graphql-tag';

export default gql`
  mutation waitForCheckForRegistration($registrationId: String!) {
    waitForCheckForRegistration(registrationId: $registrationId) {
      id
    }
  }
`;
